import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index'
import dataV from '@jiaminghi/data-view';
import './assets/scss/style.scss';
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
import './assets/Starting/iconfont_icon/iconfont.css'
import Rsa from "@/untils/rea.js"
Vue.prototype.Rsa = Rsa // 将Rsa注册为公共方法,方便其他页面调用
import scroll from 'vue-seamless-scroll';
Vue.use(scroll);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
//import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

import Moment from 'moment'
import AMap from 'vue-amap';
import SuperFlow from 'vue-super-flow'
import 'vue-super-flow/lib/index.css'
// import rea from './untils/rea.js'
import less from 'less'
Vue.use(less)
Vue.use(SuperFlow)
// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  return Moment(value).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('formatDates', function(value) {
  return Moment(value).format('YYYY-MM-DD')
})
Vue.filter('lise', function(value) {
  return Moment(value).format('MM-DD')
})
Vue.filter('time', function(value) {
  return Moment(value).format('HH:mm')
})
//全局console注释
// console.log = function() {}  
// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);
Vue.use(AMap);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
AMap.initAMapApiLoader({
  //在高德平台申请的key
  key:'86b10e00f50d8f47889df383ba94c4a8',
  plugin: ['AMap.Geolocation']
  
})
//开启js热更新
if (module.hot) {
  module.hot.accept();
}


